let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("btL2P")).then(() => parcelRequire('gxpCh'));